/**
 * The function responsible for extracting and localizing the time from the given ISO date string.
 * @param date
 * @param locale
 */
export const getLocalizedTime = (date: string, locale = "en-US") => {
  const d = new Date(date);
  return d.toLocaleTimeString(locale, { hour: "numeric", minute: "2-digit" });
};
